export default __webpack_public_path__ + "assets/models/79e444050a5906422df4ab4189ba4ec4.glb";